/* unplugin-vue-components disabled */import { render } from "./PollQuizStatistics.vue?vue&type=template&id=568b6c98&scoped=true&ts=true"
import script from "./PollQuizStatistics.vue?vue&type=script&lang=ts"
export * from "./PollQuizStatistics.vue?vue&type=script&lang=ts"

import "./PollQuizStatistics.vue?vue&type=style&index=0&id=568b6c98&scoped=true&lang=scss"
import "./PollQuizStatistics.vue?vue&type=style&index=1&id=568b6c98&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-568b6c98"]])

export default __exports__